export default {
  'component.marketingmaterials.title': 'Markedsmateriell',
  'component.marketingmaterials.card1': 'Salgsoppgave',
  'component.marketingmaterials.card1.status': 'Ikke godkjent ennå',
  'component.marketingmaterials.card2': 'DM',
  'component.marketingmaterials.card2.status': 'Godkjent 17:17, 24-02-2020',
  'component.marketingmaterials.modal.title': 'Godkjente markedsføringsmateriell',
};
